document.addEventListener("DOMContentLoaded", function () {
  const videoBlocks = document.querySelectorAll(".wp-block-video");

  videoBlocks.forEach(function (block) {
    const video = block.querySelector("video");

    video.addEventListener("play", function () {
      block.classList.add("is-playing");
    });

    video.addEventListener("pause", function () {
      block.classList.remove("is-playing");
    });
  });
});

// Check if it's an Android device
function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

// Hide play button for Android
function hidePlayButtonOnAndroid() {
  if (isAndroid()) {
    const videos = document.querySelectorAll("video");
    videos.forEach((video) => {
      video.removeAttribute("controls");
      // Optional: add custom play functionality if needed
    });
  }
}

// Run on page load
window.addEventListener("load", hidePlayButtonOnAndroid);
